<template>
  <div class="container">
    <slot />
  </div>
</template>

<style scoped>
  .container {
    @apply px-6 lg:px-8 mx-auto w-full max-w-[110rem];
  }
</style>
